import type { ApprovalKindLadder, ApprovalTierInput } from '@chukua/common';
import { api } from '../../lib/api';

export function listApprovalThresholds(): Promise<ApprovalKindLadder[]> {
  return api<ApprovalKindLadder[]>('/approval-thresholds');
}

export function updateApprovalTiers(kind: string, tiers: ApprovalTierInput[]): Promise<ApprovalKindLadder> {
  return api<ApprovalKindLadder>(`/approval-thresholds/${kind}`, { method: 'PUT', body: JSON.stringify({ tiers }) });
}
